import clsx from 'clsx';
import { FinancialStatementMonthVisualizationTypes } from 'model/enums/financial-statement-month-visualization-types';
import React from 'react';
import { useTranslation } from 'react-i18next';

import './financial-statement-month-button-switch.scss';

const I18N_PREFIX = 'anchor.financial-statement-month.switch-button';

interface ButtonSwitchProps {
    disabled?: boolean;
    handleSwitch: () => void;
    currentVisualization: FinancialStatementMonthVisualizationTypes;
}

const FinancialStatementMonthButtonSwitch = (props: ButtonSwitchProps) => {
    const { disabled, handleSwitch, currentVisualization } = props;

    const { t } = useTranslation();

    return (
        <div className="financial-statement-month-button-switch">
            <div
                className={clsx('financial-statement-month-button-switch--content', {
                    active: currentVisualization === FinancialStatementMonthVisualizationTypes.MONTHLY,
                    disabled
                })}
                onClick={() => {
                    if (currentVisualization === FinancialStatementMonthVisualizationTypes.MONTHLY) return;
                    handleSwitch();
                }}
                aria-hidden="true"
            >
                {t(`${I18N_PREFIX}.${FinancialStatementMonthVisualizationTypes.MONTHLY}`)}
            </div>
            <div
                className={clsx('financial-statement-month-button-switch--content', {
                    active: currentVisualization === FinancialStatementMonthVisualizationTypes.YEARLY,
                    disabled
                })}
                onClick={() => {
                    if (currentVisualization === FinancialStatementMonthVisualizationTypes.YEARLY) return;
                    handleSwitch();
                }}
                aria-hidden="true"
            >
                {t(`${I18N_PREFIX}.${FinancialStatementMonthVisualizationTypes.YEARLY}`)}
            </div>
        </div>
    );
};

export default FinancialStatementMonthButtonSwitch;
